import React, { useEffect, useState, useRef } from "react";
import { Card, Table, Alert, Spinner } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
export default function AppliedPartners() {
  const history = useHistory();
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [searchData, setSearchData] = useState([]);
  const [onboardUser, setOnBoardUser] = useState([]);
  const [spinner, setSpinner] = useState(true);
  function getData() {
    axios
      .get(`${Baseurl.baseurl}/onboarding/get-approve-onboarding`)
      .then((res) => {
        setSpinner(false);
        setOnBoardUser(res.data.onboardingList);
        setSearchData(res.data.onboardingList);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);
  function searchRider(value) {
    let filteredData = [];
    if (searchData) {
      searchData.map((val) => {
        let phoneString = val.Phone.toString();
        if (
          val.Name.toLowerCase().includes(value) ||
          val.Email.toLowerCase().includes(value) ||
          phoneString.includes(value)
        ) {
          filteredData.push(val);
        }
      });
      setOnBoardUser(filteredData);
    }
  }
  return (
    <Card
      style={{
        color: "white",
        background:
          "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
      }}
    >
      <Card.Header>
        <Card.Title className="text-white">All Partners</Card.Title>
        <div>
          <input
            type="text"
            className="form-control"
            placeholder="Search here..."
            onChange={(e) => {
              searchRider(e.target.value);
            }}
          />
        </div>
      </Card.Header>
      <Card.Body>
        <div id="job_data" className="dataTables_wrapper ">
          {spinner ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Table className="text-white" responsive>
              <thead>
                <tr>
                  <th>
                    <strong>SL NO.</strong>
                  </th>

                  <th>
                    <strong>NAME</strong>
                  </th>

                  <th>
                    <strong>Phone No.</strong>
                  </th>
                  <th>
                    <strong>Onboard Type</strong>
                  </th>
                  <th>
                    <strong>Address</strong>
                  </th>
                  <th>
                    <strong>Actions</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {onboardUser &&
                  onboardUser.map((rider, key) => (
                    <tr key={rider.id}>
                      <td>{key + 1}</td>
                      <td>{rider.Name}</td>
                      <td>{rider.Phone}</td>
                      <td>{rider.OnboardingType}</td>
                      <td>
                        {rider.OfficeAddress} {rider.OfficePincode}
                      </td>
                      <td>
                        <Link to={`./view-partner/${rider._id}`}>
                          <button className="btn btn-primary">View</button>
                        </Link>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}

          {!onboardUser && (
            <Alert
              variant="success"
              className="alert-dismissible fade show text-center"
            >
              Zero Partners
            </Alert>
          )}
          <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
            <div className="dataTables_info text-white">
              Showing {activePag.current * sort + 1} to{" "}
              {data.length > (activePag.current + 1) * sort
                ? (activePag.current + 1) * sort
                : data.length}{" "}
              of {data.length} entries
            </div>
            <div
              className="dataTables_paginate paging_simple_numbers"
              id="example5_paginate"
            >
              <Link
                className="paginate_button previous disabled"
                onClick={() =>
                  activePag.current > 0 && onClick(activePag.current - 1)
                }
              >
                Previous
              </Link>
              <span>
                {paggination.map((number, i) => (
                  <Link
                    key={i}
                    className={`paginate_button  ${
                      activePag.current === i ? "current" : ""
                    } `}
                    onClick={() => onClick(i)}
                  >
                    {number}
                  </Link>
                ))}
              </span>
              <Link
                className="paginate_button next"
                onClick={() => {
                  activePag.current + 1 < paggination.length &&
                    onClick(activePag.current + 1);
                }}
              >
                Next
              </Link>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
